import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'userPhoto'
})
export class UserPhotoPipe implements PipeTransform {

  apiUrl = environment.apiBaseUrl;

  transform(value: any, args?: any): any {
    if(value){
      value = this.apiUrl + value;
      return value;
    }
    return 'assets/img/empty_profile/erkek.svg';
  }

}
